// src/components/Configuracion.jsx
import React, { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  User,
  Building,
  FileText,
  Palette,
  Shield,
  Users,
  CreditCard,
  Search,
  Layout,
} from "lucide-react";
import Breadcrumb from "./Breadcrumb";
import Nav from "./Nav";
import PerfilPanel from "./PerfilPanel";
import EmpresaPanel from "./EmpresaPanel";
import FiscalPanel from "./FiscalPanel";
import SeguridadPanel from "./SeguridadPanel";
import MiPlanPanel from "./MiPlanPanel";
import PermisosUsuarios from "./PermisosUsuarios";
import Personalizacion from "./Personalizacion";
import Documentos from "./Documentos";

// Tabs
const TABS = [
  {
    id: "perfil",
    labelKey: "tabs.profile",
    icon: User,
    element: <PerfilPanel />,
  },
  {
    id: "empresa",
    labelKey: "tabs.company",
    icon: Building,
    element: <EmpresaPanel />,
  },
  {
    id: "datos-fiscales",
    labelKey: "tabs.tax",
    icon: FileText,
    element: <FiscalPanel />,
  },
  {
    id: "personalizacion",
    labelKey: "tabs.personalization",
    icon: Palette,
    element: <Personalizacion />,
  },
  {
    id: "documentos",
    labelKey: "tabs.documents",
    icon: Layout,
    element: <Documentos />,
  },
  {
    id: "seguridad",
    labelKey: "tabs.security",
    icon: Shield,
    element: <SeguridadPanel />,
  },
  {
    id: "usuarios",
    labelKey: "tabs.users",
    icon: Users,
    element: <PermisosUsuarios />,
  },
  {
    id: "suscripción",
    labelKey: "tabs.myPlan",
    icon: CreditCard,
    element: <MiPlanPanel />,
  },
];

export default function Configuracion() {
  const { t } = useTranslation();
  const [params, setParams] = useSearchParams();
  const active = params.get("tab") || "perfil";

  const activeTab = TABS.find((x) => x.id === active) || TABS[0];

  const ActiveView = useMemo(() => {
    const found = TABS.find((x) => x.id === active) || TABS[0];
    return () => found.element;
  }, [active]);

  const changeTab = (id) => setParams({ tab: id }, { replace: true });

  return (
    <>
      <Nav />

      <div className="config-page">
        <div className="config-header">
          <Breadcrumb
            aliases={{
              configuracion: t("breadcrumbs.settings", "Configuración"),
            }}
            lastLabel={t(activeTab.labelKey)}
          />

          <h1>{t("breadcrumbs.settings")}</h1>

          {/* ✅ BUSCADOR ARRIBA DE LOS TABS */}
          <div className="config-search-row">
            <label className="config-search">
              <Search size={18} className="search-icon" />
              <input
                type="search"
                placeholder={t(
                  "search.configPlaceholder",
                  "Buscar configuración...",
                )}
              />
            </label>
          </div>

          {/* ✅ TABS ABAJO */}
          <div className="config-toolbar">
            <div className="config-tabs">
              {TABS.map((tab) => {
                const IconComponent = tab.icon;
                return (
                  <button
                    key={tab.id}
                    className={`config-tab ${active === tab.id ? "active" : ""}`}
                    onClick={() => changeTab(tab.id)}
                  >
                    <IconComponent size={18} className="tab-icon" />
                    <span>{t(tab.labelKey)}</span>
                  </button>
                );
              })}
            </div>
          </div>
        </div>

        <div className="config-content">
          <ActiveView />
        </div>
      </div>
    </>
  );
}
